@if (!exclusive.isBig) {
  <section>
    <span>
      <img src="{{exclusive.imageUrl}}" alt="">
    </span>
    <div>
      <h3>{{exclusive.title}}</h3>
      <p>{{exclusive.text}}</p>
    </div>
  </section>
}
@if (exclusive.isBig) {
  <div class="bigCard">
    <div class="exclusiveImg" [style]="'background-image: url(' + exclusive.imageUrl + ')'">
    </div>
    <div class="content">
      <h3>{{exclusive.title}}</h3>
      <p>{{exclusive.text}}</p>
      <a type="button" class="regular button" [href]="exclusive.buttonUrl" target="_blank" >{{exclusive.buttonCTA}}</a>
    </div>
  </div>
}
